import type { Maybe } from '@/frontend-types'
import type { VariantProps } from 'cva'
import { cva, cx } from 'cva'
import type { FC } from 'react'

export type TextAreaContentProps = {
	text?: Maybe<string>
	className?: string
	textSize?: SpacingVariants['textSize']
	layoutNarrowTextSize?: SpacingVariants['layoutNarrowTextSize']
}

const spacingVariants = cva({
	variants: {
		textSize: {
			'text-body-xs': 'text-body-xs space-y-md',
			'text-body-sm': 'text-body-sm space-y-lg',
			'text-body-md': 'text-body-md space-y-xl',
			'text-body-lg': 'text-body-lg space-y-xl',
			'text-display': 'text-display space-y-xl',
			'custom-default': 'space-y-xl',
		},
		layoutNarrowTextSize: {
			'layout-narrow:text-body-xs': 'layout-narrow:text-body-xs layout-narrow:space-y-md',
			'layout-narrow:text-body-sm': 'layout-narrow:text-body-sm layout-narrow:space-y-lg',
			'layout-narrow:text-body-md': 'layout-narrow:text-body-md layout-narrow:space-y-xl',
			'layout-narrow:text-body-lg': 'layout-narrow:text-body-lg layout-narrow:space-y-xl',
			'layout-narrow:text-display': 'layout-narrow:text-display layout-narrow:space-y-xl',
		},
	},
	defaultVariants: {
		textSize: 'custom-default',
	},
})

type SpacingVariants = VariantProps<typeof spacingVariants>

export const TextAreaContent: FC<TextAreaContentProps> = ({
	text,
	className,
	textSize,
	layoutNarrowTextSize,
}) => {
	if (!text) return null

	return (
		<div className={cx(className, spacingVariants({ textSize, layoutNarrowTextSize }))}>
			{text
				.trim()
				.split('\n')
				.filter((line) => line !== '')
				.map((line, index) => {
					const content = line.trim()
					const lineKey = `${content || 'empty'}-${index}`
					return <p key={lineKey}>{content}</p>
				})}
		</div>
	)
}
